export class UiError {
    constructor() {
        this.hasErrorFlag = false;
        this.errorMessage = '';
        this.severity = 'normal';
    }
}
//# sourceMappingURL=uiError.js.map